<template>
  <div :class="$attrs.class" class="form-group w-full">
    <ValidationProvider v-slot="{ errors }" :name="name" :rules="rules" v-bind="$attrs">
      <label v-if="label" :class="labelClass" class="block text-base font-normal mb-1">{{ label }}<b
          v-if="isRequired" class="ml-1 text-red-600 font-bold">*</b></label>
      <div class="relative input-group">
        <div v-if="leftIcon" class="icon-left"><i :class="leftIcon"></i></div>
        <textarea :class="['form-control',inputClass, leftIcon ? 'pl-10' : '', rightIcon ? 'pr-10' : '', value !== '' ? 'bg-white' : 'bg-gray-100']"
                  :cols="cols"
                  :rows="rows"
                  :value="value"
                  autocomplete="off"
                  v-bind="$attrs" @input="onChange"/>
        <div v-if="rightIcon" class="icon-right"><i :class="rightIcon"></i></div>
      </div>
      <span class="text-xs text-red-600">{{ errors[0] }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: "TextArea",
  props: ["value", "label", "leftIcon", "rightIcon", "labelClass", "rules", "name", "cols", "rows", "inputClass"],
  computed: {
    isRequired() {
      return this.required || this.rules?.search("required") > -1;
    }
  },
  // watch: {
  //   value(val) {
  //     this.modelData = val;
  //   }
  // },
  // created() {
  //   this.modelData = this.value;
  // },
  methods: {
    onChange(e) {
      // this.modelData = e.target.value;
      this.$emit("input", e.target.value);
    }
  }
}
</script>
